import {
  Button,
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@wundo/ui';
import { m } from '@/paraglide/messages.js';

export interface OfflineRecordingResumeDialogProps {
  open: boolean;
  pending: boolean;
  failed: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

/**
 * The confirm in front of picking an interrupted recording back up.
 *
 * Asked rather than done, because resuming is not free: the microphone opens
 * again, and whatever was said while the page was gone is not coming back. The
 * dialog says both — what is kept and what is lost — so that "hervatten" is a
 * decision rather than a hopeful click.
 */
export function OfflineRecordingResumeDialog({
  open,
  pending,
  failed,
  onConfirm,
  onCancel,
}: OfflineRecordingResumeDialogProps) {
  return (
    <Dialog open={open} onOpenChange={(next) => !next && onCancel()}>
      <DialogContent size='md'>
        <DialogHeader>
          <DialogTitle>{m.meeting_offline_resume_title()}</DialogTitle>
        </DialogHeader>

        <div className='flex flex-col gap-2.5 px-5 py-4'>
          <p className='text-sm text-ink-body'>{m.meeting_offline_resume_body()}</p>
          {failed && (
            <p role='alert' className='text-sm text-danger'>
              {m.meeting_offline_start_failed()}
            </p>
          )}
        </div>

        <DialogFooter>
          <Button size='sm' variant='quiet' onClick={onCancel}>
            {m.meeting_cancel()}
          </Button>
          <Button size='sm' disabled={pending} onClick={onConfirm}>
            {m.meeting_offline_resume_confirm()}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
